import BottomDecoration from "@/assets/img/profile/advisorQuiz/quiz_bottom_decoration.webp"
import BackArrow from "@/assets/img/profile/back_arrow.svg?react"
import Chevron from "@/assets/img/profile/menu/chevron_right.svg?react"

import type { QuizStep } from "../../config/quiz-steps"

interface QuizQuestionProps {
  step: QuizStep
  /** Zero-based step index (0–5), drives the progress bar. */
  index: number
  onBack: () => void
  onSelect: (value: string) => void
}

/** One question step: header progress + title + options. Ported from AdvisorsQuiz question layout. */
export function QuizQuestion({ step, index, onBack, onSelect }: QuizQuestionProps) {
  return (
    <div className="relative min-h-[100dvh] bg-dark-base">
      <img
        src={BottomDecoration}
        alt=""
        className="pointer-events-none absolute inset-x-0 bottom-0 w-full select-none"
      />

      <div className="relative z-[1] mx-auto flex w-full max-w-[500px] flex-col items-center gap-8">
        <div className="w-full">
          <div className="relative flex h-14 items-center justify-center">
            <button type="button" onClick={onBack} className="absolute left-4 top-4 [&_svg]:size-6">
              <BackArrow />
            </button>
            <h2 className="font-display text-[22px] font-medium text-purple-light">
              Who&apos;s your ideal guide?
            </h2>
          </div>
          <div className="h-1 w-full bg-purple-light/20">
            <div
              className="h-full bg-main-purple transition-[width]"
              style={{ width: `${(index / 6) * 100}%` }}
            />
          </div>
        </div>

        <div className="flex w-full max-w-[500px] flex-col items-center gap-2 px-4 text-center">
          <h3 className="font-display text-2xl font-medium text-purple-light">{step.title}</h3>
          <p className="font-body text-base text-purple-light/70">{step.subtitle}</p>
        </div>

        <div className="flex w-full max-w-[500px] flex-col gap-2 px-4 pb-[170px]">
          {step.options.map((option) => {
            const Icon = option.Icon
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => onSelect(option.value)}
                className="flex min-h-14 items-center gap-3 rounded-xl bg-purple-light/10 py-3 pl-4 pr-2 text-left backdrop-blur-[15px]"
              >
                <span className="flex min-w-0 flex-1 items-center gap-3">
                  {Icon && (
                    <span className="flex size-8 shrink-0 items-center justify-center [&_svg]:size-8">
                      <Icon />
                    </span>
                  )}
                  <span className="font-body text-base font-semibold text-purple-light">
                    {option.label}
                  </span>
                </span>
                <span className="flex size-6 shrink-0 items-center justify-center text-purple-light [&_svg]:w-2">
                  <Chevron />
                </span>
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
